import { CURRENT_USER_FILTER_TOKEN } from 'tsui';
import { User } from '@core/models';

type FilterUser = Pick<User, 'id' | 'full_name'>;

export const hasCurrentUserFilterToken = (fjson: string | undefined): boolean =>
  !!fjson?.includes(CURRENT_USER_FILTER_TOKEN);

const resolveValue = (value: unknown, user: FilterUser): unknown => {
  if (Array.isArray(value)) {
    return value.map((entry) => {
      if (entry === CURRENT_USER_FILTER_TOKEN) {
        // a select field's value: bare ids
        return user.id;
      }

      // a record field's value: [id, label] pairs
      return Array.isArray(entry) && entry[0] === CURRENT_USER_FILTER_TOKEN ? [user.id, user.full_name] : entry;
    });
  }

  return value === CURRENT_USER_FILTER_TOKEN ? user.id : value;
};

/**
 * Swaps the `$CURRENT_USER` token in a filter's fjson for the signed-in user, in the same shape the filter would hold
 * had that user been picked from the value list. Meant for the moment a query is sent: what is saved keeps the token.
 */
export const resolveCurrentUserFjson = (fjson: string, user: FilterUser | null | undefined): string => {
  if (!user || !hasCurrentUserFilterToken(fjson)) {
    return fjson;
  }

  const rows = JSON.parse(fjson) as unknown[][];

  return JSON.stringify(rows.map((row) => row.map((part, index) => (index === 2 ? resolveValue(part, user) : part))));
};
